import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthService } from '../../shared/services/auth.service'

/**
 * Gère l'authentification au compte Google (redirections vers page login Google, vérification du token etc.)
 */
export function authGuard(): CanActivateFn {
  return () => {
    const authService: AuthService = inject(AuthService)
    return authService.connectUserIfNecessary()
  }
}
